import React, { useState } from 'react';
import {
    IonModal,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonLabel,
    IonInput,
    IonButton,
    IonItem,
    IonRow,
    IonCol,
    IonFooter,
    useIonAlert, IonIcon,
} from '@ionic/react';
import {
    actionToGetNewsLettersByFilter, actionToUpdateNewsLetterPortalDataWithPdf,
    actionToUploadNewsLetterPortalDataWithPdf
} from "../apiHelpers/CommonAction";
import useStore from "../zustand/useStore";
import imageCompression from "browser-image-compression";
import {star} from "ionicons/icons";

export default function AddNewsLetterModal({ isOpen, onClose, setIsLoading,dataForEditing }) {
    const [form, setForm] = useState({
        image: '',
        caption: '',
        pdf: '',
        newsletter_date: '',
    });

    const {resetNewsLetterFilters,newsLettersDataState} = useStore();

    const [errors, setErrors] = useState({});
    const [presentAlert] = useIonAlert();

    React.useEffect(()=>{
        if(dataForEditing?.id){
            let formattedDate = '';
            if (dataForEditing.newsletter_date) {
                // Convert to YYYY-MM-DD format
                const d = new Date(dataForEditing.newsletter_date);
                formattedDate = d.toISOString().split('T')[0];
            }
            setForm({
                caption: dataForEditing.caption || '',
                newsletter_date: formattedDate || '',
                image: null, // keep null unless user uploads new one
                pdf: null,   // keep null unless user uploads new one
            })
        }
    },[dataForEditing, isOpen])


    const handleChange = (field, value) => {
        setForm((prev) => ({ ...prev, [field]: value }));
    };

    const validate = () => {
        const newErrors = {};
        if (!form.caption) newErrors.caption = 'Caption is required';
        if (!form.newsletter_date) newErrors.newsletter_date = 'Newsletter date is required';
        if(!dataForEditing?.id) {
            if (!form?.image) newErrors.image = 'Image is required';
            if (!form?.pdf) newErrors.pdf = 'PDF is required';
        }
        return newErrors;
    };


    const handleImageUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1200,
            useWebWorker: true,
        };

        try {
            const compressedBlob = await imageCompression(file, options);

            // wrap into File (important!)
            const compressedFile = new File([compressedBlob], file.name, {
                type: compressedBlob.type,
                lastModified: Date.now(),
            });

            handleChange('image', compressedFile);
        } catch (error) {
            console.error("Image compression error:", error);
        }
    };

    const handlePdfUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            handleChange('pdf',file);
        }
    };

    const handleSubmit = () => {
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setErrors({});
        setIsLoading(true);

        const formData = new FormData();
        formData.append('caption', form.caption);
        formData.append('newsletter_date', form.newsletter_date);

        if(dataForEditing?.id){
            formData.append('id', dataForEditing?.id);
        }

        if(form.image) formData.append('image', form.image);
        if(form.pdf) formData.append('pdf', form.pdf);

        const apiCall = dataForEditing?.id ? actionToUpdateNewsLetterPortalDataWithPdf(formData) :
        actionToUploadNewsLetterPortalDataWithPdf(formData);

        apiCall.then(() => {
                setIsLoading(false);
                resetNewsLetterFilters()
            if(dataForEditing?.id) {
                actionToGetNewsLettersByFilter(false,{offset:newsLettersDataState?.offset});
            }else{
                actionToGetNewsLettersByFilter();
            }
                dismissModal(); // ✅ Close modal only after success
            })
            .catch(() => {
                setIsLoading(false);
                presentAlert({
                    message: 'Something went wrong while uploading.',
                    buttons: ['OK'],
                });
            });
    };

    const dismissModal = ()=>{
        setForm({image: '',
            caption: '',
            pdf: '',
            newsletter_date: '',})
        onClose()
    }
    return (
        <IonModal
            isOpen={isOpen}
            onDidDismiss={dismissModal}
            initialBreakpoint={1}
            breakpoints={[0, 1]}
            handleBehavior="cycle"
        >
            <IonHeader className="job_detail_sheet_header sheet_modal_header">
                <IonToolbar>
                    <IonTitle>Add Newsletter</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent className="ion-padding bottom-2 no_padding_top">
                <div>
                    <div className="rfp_submit_form_item">
                        <IonLabel>Caption<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonInput
                            placeholder="Enter newsletter caption"
                            className="rfp_form_input"
                            value={form.caption}
                            onIonInput={(e) => handleChange('caption', e.detail.value)}
                        />
                    </div>
                    {errors.caption && <p className="error-text">{errors.caption}</p>}

                    <div className="rfp_submit_form_item">
                        <IonLabel>Newsletter Date<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonInput
                            type="date"
                            className="rfp_form_input"
                            value={form.newsletter_date}
                            onIonInput={(e) => handleChange('newsletter_date', e.detail.value)}
                        />
                    </div>
                    {errors.newsletter_date && <p className="error-text">{errors.newsletter_date}</p>}

                    <div className="rfp_submit_form_item">
                        <IonLabel>Upload Image<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonItem className="ion-no-padding ion-margin-bottom">
                            <input
                                className="attach-pdf"
                                type="file"
                                accept="image/*"
                                onChange={handleImageUpload}
                            />
                        </IonItem>
                    </div>
                    {dataForEditing?.id && !form.image && (
                        <small>Current: {dataForEditing.image_url}</small>
                    )}
                    {errors.image && <p className="error-text">{errors.image}</p>}

                    <div className="rfp_submit_form_item">
                        <IonLabel>Upload PDF<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonItem className="ion-no-padding ion-margin-bottom">
                            <input
                                className="attach-pdf"
                                type="file"
                                accept="application/pdf"
                                onChange={handlePdfUpload}
                            />
                        </IonItem>
                    </div>
                    {dataForEditing?.id && !form.pdf && (
                        <small>Current: {dataForEditing.pdf_url}</small>
                    )}
                    {errors.pdf && <p className="error-text">{errors.pdf}</p>}
                </div>
            </IonContent>

            <IonFooter className="job_detail_sheet_footer ion-padding">
                <IonToolbar>
                <IonRow>
                    <IonCol>
                        <IonButton className="close_job_detail_button" expand="block" onClick={dismissModal}>
                            Close
                        </IonButton>
                    </IonCol>
                    <IonCol>
                        <IonButton className="apply_job_button" expand="block" onClick={handleSubmit}>
                            {dataForEditing?.id ? "Update Newsletter" : 'Submit Newsletter'}
                        </IonButton>
                    </IonCol>
                </IonRow>
                </IonToolbar>
            </IonFooter>
        </IonModal>
    );
}
